import type Rollbar from 'rollbar';

const scrubFields = [
  'password',
  'passwd',
  'secret',
  'token',
  'accessToken',
  'refreshToken',
  'authorization',
  'cookie',
  'csrf_token',
  'credentials',
];

/**
 * Temporary suppression list. These are expected/benign backend responses (mostly 4xx
 * "not found" / access-denied bodies) that surface as Rollbar occurrences and add noise.
 * Each entry is matched as a regex against the occurrence message.
 *
 * TODO: Remove once the underlying flows handle these responses gracefully instead of
 * letting them bubble up as uncaught errors / unhandled rejections.
 */
export const ignoredMessages = [
  'Booking not found',
  'No interchange found',
  'No suitable contract found',
  'The given id must not be null',
  'AccessDeniedException: Access Denied',
];

/** True when `text` contains one of the temporarily-suppressed benign backend messages. */
export const isIgnoredErrorMessage = (text: string): boolean =>
  ignoredMessages.some(message => text.includes(message));

function resolveRollbarEnvironment(): string {
  const tier = process.env.REACT_APP_ROLLBAR_ENVIRONMENT?.trim();
  return tier || process.env.NODE_ENV || 'development';
}

/**
 * Rollbar client config for @rollbar/react Provider.
 * When `REACT_APP_ROLLBAR_ACCESS_TOKEN` is unset, reporting is disabled and the app still runs.
 */
export function getRollbarConfig(): Rollbar.Configuration {
  const accessToken = process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN?.trim();
  const gitSha = process.env.REACT_APP_GIT_SHA?.trim();
  const hasToken = Boolean(accessToken);

  return {
    ...(accessToken ? { accessToken } : {}),
    enabled: hasToken,
    environment: resolveRollbarEnvironment(),
    captureUncaught: hasToken,
    captureUnhandledRejections: hasToken,
    ignoredMessages,
    scrubFields,
    ...(gitSha ? { codeVersion: gitSha } : {}),
  };
}
